/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosAbsenceTypesAbsenceTypeDto,
  FacilityFlowCoreModulesPlanningDtosAbsenceTypesCreateAbsenceTypeRequest,
  FacilityFlowCoreModulesPlanningDtosAbsenceTypesUpdateAbsenceTypeRequest,
  GetApiV1AbsenceTypesParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getAbsenceTypes = () => {
/**
 * @summary Get all absence types
 */
const getApiV1AbsenceTypes = (
    params?: GetApiV1AbsenceTypesParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsenceTypesAbsenceTypeDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsenceTypesAbsenceTypeDto[]>(
      {url: `/api/v1/absence-types`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a new absence type
 */
const postApiV1AbsenceTypes = (
    facilityFlowCoreModulesPlanningDtosAbsenceTypesCreateAbsenceTypeRequest: FacilityFlowCoreModulesPlanningDtosAbsenceTypesCreateAbsenceTypeRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsenceTypesAbsenceTypeDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsenceTypesAbsenceTypeDto>(
      {url: `/api/v1/absence-types`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosAbsenceTypesCreateAbsenceTypeRequest
    },
      options);
    }
  /**
 * @summary Update an absence type. The code is immutable — absence semantics key off it.
 */
const putApiV1AbsenceTypesId = (
    id: string,
    facilityFlowCoreModulesPlanningDtosAbsenceTypesUpdateAbsenceTypeRequest: FacilityFlowCoreModulesPlanningDtosAbsenceTypesUpdateAbsenceTypeRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsenceTypesAbsenceTypeDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsenceTypesAbsenceTypeDto>(
      {url: `/api/v1/absence-types/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosAbsenceTypesUpdateAbsenceTypeRequest
    },
      options);
    }
  return {getApiV1AbsenceTypes,postApiV1AbsenceTypes,putApiV1AbsenceTypesId}};
export type GetApiV1AbsenceTypesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsenceTypes>['getApiV1AbsenceTypes']>>>
export type PostApiV1AbsenceTypesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsenceTypes>['postApiV1AbsenceTypes']>>>
export type PutApiV1AbsenceTypesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsenceTypes>['putApiV1AbsenceTypesId']>>>
